<div class="topbar flex items-center px-4 gap-3">
  <a
    (click)="app.onMenuButtonClick($event)"
    class="text-xl cursor-pointer text-surface-600 hover:text-primary-500 pt-0.5"
    href="#"
    id="menu-button"
    pRipple>
    <i class="fal fa-bars"></i>
  </a>

  <img alt="tacs® Logo" class="h-6 sm:h-8" src="assets/logo/tacs_text.svg" />

  <div class="flex-1 min-w-0"></div>

  <span class="topbar-context hidden sm:flex">
    <p-select
      (onChange)="tenantSelected()"
      [dataKey]="'id'"
      [filter]="true"
      [filterFields]="['label']"
      [formControl]="selectedTenant"
      [group]="isMandant()"
      [options]="anwenderbetriebOptions"
      [style]="{ visibility: this.isGlobal() ? 'hidden' : 'visible' }"
      appScrollIntoView></p-select>
  </span>

  <span class="topbar-language flex items-center gap-1">
    @for (language of languages; track $index; let last = $last) {
      <span
        (click)="changeLanguage(language)"
        [class.font-bold]="language === currentLanguage"
        class="cursor-pointer text-surface-600 hover:text-primary-500">
        {{ language.toUpperCase() }}
      </span>
      @if (!last) {
        <span class="text-surface-300">|</span>
      }
    }
  </span>

  <a
    (click)="app.onTopbarMenuButtonClick($event)"
    class="flex items-center gap-2 cursor-pointer text-surface-600 hover:text-primary-500"
    href="#">
    <span class="hidden lg:inline">{{ username }}</span>
    <i class="fal fa-user-circle text-2xl"></i>
    <i class="fal fa-angle-down text-sm"></i>
  </a>

  <ul [ngClass]="{ 'topbar-menu-visible': app.topbarMenuActive }" class="topbar-menu">
    <li>
      <a [href]="this.changePasswordUrl" pRipple>
        <i class="topbar-icon fal fa-key"></i>
        <span class="topbar-item-name" translate>GLOBAL.CHANGE_PASSWORD</span>
      </a>
      <a [href]="this.twoFactorAuthUrl" pRipple>
        <i class="topbar-icon fal fa-qrcode"></i>
        <span class="topbar-item-name" translate>GLOBAL.TWO_FACTOR_AUTHENTICATION</span>
      </a>
      <a (click)="logout(); $event.preventDefault()" href="#" pRipple>
        <i class="topbar-icon fal fa-sign-out"></i>
        <span class="topbar-item-name" translate>GLOBAL.SIGN_OUT</span>
      </a>
    </li>
  </ul>
</div>
